import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Client } from '../../models/client';
import { RestService } from "../rest.service";
import { Configuration } from '../../app.constants';

@Injectable()
export class ClientService extends RestService {

    constructor(_http: HttpClient, _configuration: Configuration) {
        super(_http,_configuration);
        this.modelName = 'client';
        this.modelClass = Client;
    }

}
